<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Moira Brown is a retired teacher, living in Newcastle, Australia. The idea of writing <em>The Bremen Singers</em> came from taking her grandchildren to the local Young People’s Theatre, and from buying some photographs of Bremen, which now hang on a wall in her home. Thus the work started off as a play, then a musical, before it was put into book form.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?87f35f66